import {
  SMART_SEARCH_CARRIER_CODE_FLIGHT_NUMBER_REGEX,
  SMART_SEARCH_FLIGHT_NUMBER_REGEX,
} from '../../../src/constants/auto-suggest-constants';

export default function interpretSearchString(text) {
  const originalText = text;
  const query = text.replace(' to ', ' ')
    .replace('->', ' ')
    .replace('-', ' ');

  const gramMatch = {};
  const carrierAndFlightNumberMatch =
    text.match(SMART_SEARCH_CARRIER_CODE_FLIGHT_NUMBER_REGEX);
  const flightNumberMatch = text.match(SMART_SEARCH_FLIGHT_NUMBER_REGEX);

  if (carrierAndFlightNumberMatch) {
    // [1] = carrier code
    // [2] = flightNumber
    gramMatch.carrier = carrierAndFlightNumberMatch[1];
    gramMatch.flightNumber = carrierAndFlightNumberMatch[2];
  } else if (flightNumberMatch) {
    gramMatch.flightNumber = flightNumberMatch[1];
  }

  if (originalText.includes(' to ')) {
    const splitTest = originalText.split(' to ');
    const leftSide = splitTest[0].split(' ');
    const rightSide = splitTest[1].split(' ');
    gramMatch.departure = leftSide[leftSide.length - 1];
    gramMatch.arrival = rightSide[0];
  }

  gramMatch.gram = query;

  return gramMatch;
}



// WEBPACK FOOTER //
// ./shared/lib/search-parser/index.js